
import {IntegrationPlatformType} from "../models/integration.model";
import {Moment} from "moment";
import * as moment from 'moment';

export enum IntegrationImportColumn {
  OPERATION = 'OPERATION',
  START_DATE = 'START_DATE',
  FINISH_DATE = 'FINISH_DATE',
  STATUS = 'STATUS',
  CONTACTS_CREATED = 'CONTACTS_CREATED',
  CONTACTS_UPDATED = 'CONTACTS_UPDATED',
  CONTACTS_REJECTED = 'CONTACTS_REJECTED',
  INTEGRATION_TYPE = 'INTEGRATION_TYPE'
}

export enum IntegrationImportStatus {
  STARTED = 'STARTED',
  FAILED = 'FAILED',
  FINISHED = 'FINISHED'
}

export enum IntegrationImportOperation {
  IMPORT = 'IMPORT',
  RESYNC = 'RESYNC',
  AUTO_RESYNC = 'AUTO_RESYNC'
}

export enum Order {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface Column {
  name: string;
}

export interface Pager {
  limit: number;
  page: number;
}

export interface IntegrationImportState {
  data: IntegrationImportResult;
  params: IntegrationImportParams;
}

export interface IntegrationImportErrorsState {
  data: IntegrationImportErrorResult;
  params: IntegrationImportErrorsParams;
}

export interface IntegrationImportParams {
  pager?: Pager;
  sortBy?: IntegrationImportColumn;
  order?: Order;
  dateFrom?: Moment;
  dateTo?: Moment;
  platforms?: IntegrationPlatformType[];
  statuses?: IntegrationImportStatus[];
  operations?: IntegrationImportOperation[];
  search?: string;
}

export class DefaultIntegrationImportParams implements IntegrationImportParams {
  pager = {
    limit: 10,
    page: 1
  };
  dateFrom = moment().subtract(7, 'day');
  dateTo = moment();
  platforms = [];
  operations = [];
  statuses = [];
  sortBy = IntegrationImportColumn.START_DATE;
  order = Order.DESC;
  search = null;
}

export interface IntegrationImportResult {
  data: IntegrationImport[];
  total: number;
}

export interface IntegrationImportErrorResult {
  data: IntegrationImportError[];
  total: number;
}

export interface IntegrationImport {
  id: number;
  operation: IntegrationImportOperation;
  startDate: Date;
  finishDate: Date;
  status: IntegrationImportStatus;
  contactsCreated: number;
  contactsUpdated: number;
  contactsRejected: number;
  integrationType: IntegrationPlatformType;
}

export interface IntegrationImportError {
  id: number;
  importId: number;
  sourceObjectId: string;
  msisdn: string;
  reason: string;
}

export enum IntegrationImportErrorColumn {
  MSISDN = 'MSISDN',
  SOURCE_OBJECT_ID = 'SOURCE_OBJECT_ID',
  REASON = 'REASON'
}

export interface IntegrationImportErrorsParams {
  pager: Pager;
  sortBy: IntegrationImportErrorColumn;
  order: Order;
  importId: number;
}

export class DefaultIntegrationImportErrorsParams implements IntegrationImportErrorsParams {
  constructor(importId: string) {
    this.importId = importId;
  }

  pager = {
    limit: 10,
    page: 1
  };
  sortBy = IntegrationImportErrorColumn.SOURCE_OBJECT_ID;
  order = Order.DESC;
  importId = null;
}
